
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.68 14.66"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Bảng_My_Bookings","data-name":"Bảng My Bookings"}},[_c('g',{attrs:{"id":"Mắt"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M12.14 14.66h-9.6A2.54 2.54 0 010 12.12V2.54A2.54 2.54 0 012.54 0h9.6a2.54 2.54 0 012.54 2.54v9.58a2.54 2.54 0 01-2.54 2.54zM2.54 1A1.54 1.54 0 001 2.54v9.58a1.54 1.54 0 001.54 1.54h9.6a1.54 1.54 0 001.53-1.54V2.54A1.54 1.54 0 0012.14 1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M6.75 10.86a.48.48 0 01-.32-.13L3.21 7.67A.47.47 0 013.87 7l2.81 2.66 4-5.67a.49.49 0 01.66-.12.48.48 0 01.12.66l-4.32 6.12a.44.44 0 01-.34.2z"}})])])])])
          )
        }
      }
    